import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import { HelmetProvider } from 'react-helmet-async';
import './i18n';

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import BookingPage from "./pages/BookingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import EmbeddedPayment from "./pages/EmbeddedPayment";
import BookingsAdmin from "./pages/BookingsAdmin";
import AdminDashboard from "./pages/AdminDashboard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CancellationPolicy from "./pages/CancellationPolicy";
import MemeMakerLanding from "./pages/MemeMakerLanding";
import MemeMakerEditor from "./pages/MemeMakerEditor";
import AboutPage from "./pages/AboutPage";
import ProtectedRoute from "./components/ProtectedRoute";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import ExitIntentPopup from "./components/ExitIntentPopup";
import MobileBottomNav from "./components/MobileBottomNav";

// Routes where conversion widgets should NOT appear
const HIDDEN_ROUTES = ['/admin', '/bookings-admin', '/login', '/payment', '/meme-landing', '/meme-maker'];

function ConversionWidgets() {
  const location = useLocation();
  if (HIDDEN_ROUTES.some((p) => location.pathname.startsWith(p))) return null;
  return (
    <>
      <WhatsAppFloatingButton />
      <ExitIntentPopup />
      <MobileBottomNav />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <Toaster position="top-right" theme="dark" richColors />
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              
              {/* Meme Maker App */}
              <Route path="/meme-landing" element={<MemeMakerLanding />} />
              <Route path="/meme-maker" element={<MemeMakerEditor />} />
              
              {/* Legal pages */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/cancellation" element={<CancellationPolicy />} />
              <Route path="/about" element={<AboutPage />} />
              
              {/* Public booking - no auth required */}
              <Route path="/book/*" element={<BookingPage />} />
              <Route path="/payment" element={<EmbeddedPayment />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              
              {/* Simple bookings admin */}
              <Route path="/bookings-admin" element={<BookingsAdmin />} />
              
              {/* Admin routes */}
              <Route 
                path="/admin/*" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ConversionWidgets />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
